import EcoSection from 'eco-design/base/eco-section';
import { FC } from 'react';

import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import MinTitle from '../MinTitle';
import styled from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
interface SpreadProps {
    pageType: string;
}

const Spread: FC<SpreadProps> = ({ pageType = 'normal' }) => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.Spread');

    return (
        <div className={`${styled.Spread} GtmModuleData-section`} data-section-id="Essentials" data-section-title={t('title')}>
            <div className="essentials-box">
                <div className="essentials-box-info">
                    <MinTitle title={t('label')} align="center" />
                    <EcoSection subTitle={t('desc')} title={t('title')} className="product-section" subTitleColor="#696C71" />
                </div>
                <div className="flex-wrapper">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747997664052/1-pc.jpg" />
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747997663869/2-pc.jpg" />
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747997663678/3-pc.jpg" />
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747997663499/4-pc.jpg" />
                </div>
            </div>
        </div>
    );
};

export default Spread;
